class AnnouncementBar extends HTMLElement {
  constructor() {
    super()
    this.countdownWrappers = this.querySelectorAll('.announcement__countdown')
  }

  connectedCallback() {
    this.countdownTimers = []
    if (!this.countdownWrappers.length)
      this.countdownWrappers = this.querySelectorAll('.announcement__countdown')
    this.countdownWrappers.forEach((countdown, index) => {
      this.renderCountdown(countdown)
      this.countdownTimers.push(
        setInterval(this.renderCountdown.bind(this, countdown, index), 1000)
      )
    })
  }

  disconnectedCallback() {
    this.countdownTimers.forEach((timer) => clearInterval(timer))
  }

  renderCountdown(element, index) {
    if (element.dataset.countdown) {
      const { days, hours, minutes, seconds } = this.getTimeUntil(
        JSON.parse(element.dataset.countdown)
      )
      const isCountdownOver =
        days === 0 && hours === 0 && minutes === 0 && seconds === 0
      if (isCountdownOver) {
        element.remove()
        clearInterval(this.countdownTimers[index])
      }
      element.innerText = `${days} days : ${hours} hours : ${minutes} minutes : ${seconds} seconds`
    }
  }

  getTimeUntil(data) {
    const { year, month, day, hours, minutes } = data
    const now = new Date()
    const targetDate = new Date(year, month - 1, day, hours, minutes) // month is 0-based in JS
    const diffMs = targetDate - now // Difference in milliseconds

    if (diffMs < 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 } // In case the date is in the past

    const seconds = Math.floor((diffMs / 1000) % 60)
    const minutesRemaining = Math.floor((diffMs / 1000 / 60) % 60)
    const hoursRemaining = Math.floor((diffMs / (1000 * 60 * 60)) % 24)
    const daysRemaining = Math.floor(diffMs / (1000 * 60 * 60 * 24))

    return {
      days: daysRemaining,
      hours: hoursRemaining,
      minutes: minutesRemaining,
      seconds,
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar)
